import React, { useState } from "react";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";

import ManualSubscriptionSimpleForm from "./form";
import { ManualSubscriptionSimpleFormType } from "./form-type";
import { FixUserState } from "@/api/services/subscriptions";

import DashboardContent from "@/components/app/DashboardContent";
import DashboardHeader from "@/components/app/DashboardHeader";
import ROUTE_CONSTANTS from "@/constants/route-constants";

const ManualSubscriptionSimpleWrapper: React.FC = () => {
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);

    const handleSubmit = async (values: ManualSubscriptionSimpleFormType, resetForm?: () => void) => {
        setSubmitLoading(true);

        try {
            // Prepare payload matching FixUserStateBody interface
            const payload = {
                userId: values.userId,
                ...(values.activeTier && { activeTier: values.activeTier }),
                ...(values.hasSubscription !== undefined && { hasSubscription: values.hasSubscription }),
            };

            console.log("Form submitted with payload:", payload);

            // Call the actual API endpoint
            await FixUserState(payload);

            enqueueSnackbar("User state updated successfully!", { variant: "success" });
            if (resetForm) resetForm();
        } catch (error) {
            enqueueSnackbar("Error updating user state", { variant: "error" });
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <>
            <DashboardHeader
                title="Manual Subscription Simple"
                titleSuffix={
                    <Button component="a" href={ROUTE_CONSTANTS.DASHBOARD.ROOT.ABSOLUTE}>
                        Back To Dashboard
                    </Button>
                }
            />
            <DashboardContent>
                <ManualSubscriptionSimpleForm loading={submitLoading} onSubmit={handleSubmit} />
            </DashboardContent>
        </>
    );
};

export default ManualSubscriptionSimpleWrapper;
